"use client";

import { Button } from "@shared/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@shared/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/components/ui/tooltip";
import { IconDotsVertical } from "@tabler/icons-react";
import type { ReactNode } from "react";

export type RowActionItem = {
  label: string;
  icon: ReactNode;
  onSelect: () => void;
  variant?: "default" | "destructive";
  disabled?: boolean;
  disabledTooltip?: string;
};

type RowActionsMenuProps = {
  label: string;
  items: RowActionItem[];
};

export const RowActionsMenu = ({ label, items }: RowActionsMenuProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="text-muted-foreground hover:text-foreground size-8"
          aria-label={label}
        >
          <IconDotsVertical className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {items.map((item) =>
          item.disabled && item.disabledTooltip ? (
            <Tooltip key={item.label}>
              <TooltipTrigger asChild>
                <span className="block w-full">
                  <DropdownMenuItem variant={item.variant} disabled onClick={item.onSelect}>
                    {item.icon}
                    {item.label}
                  </DropdownMenuItem>
                </span>
              </TooltipTrigger>
              <TooltipContent className="max-w-xs text-balance">{item.disabledTooltip}</TooltipContent>
            </Tooltip>
          ) : (
            <DropdownMenuItem key={item.label} variant={item.variant} disabled={item.disabled} onClick={item.onSelect}>
              {item.icon}
              {item.label}
            </DropdownMenuItem>
          ),
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
